import { combineReducers } from 'redux';
import list from './list';
import categories from './categories';

export default combineReducers({
  list,
  categories,
});
